import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class OnSiteInductionProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'onSiteInduction'}
            title={ t('support.procedure.P17.title') }
            exportTitle={ t('support.procedure.P17.exportTitle') }
            exportFileName={'on_site_induction.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (OnSiteInductionProcedure);
